import { httpsCallable } from "firebase/functions";
import { functions } from "../firebase";

const invoke = (name, data) => httpsCallable(functions, name)(data).then((response) => response.data);

export const authorizeZunoCardRide = (rideId, cardId) => invoke("authorizeZunoCardRide", { rideId, cardId });
export const captureZunoCardRide = (rideId) => invoke("captureZunoCardRide", { rideId });
export const cancelZunoCardRide = (rideId) => invoke("cancelZunoCardRide", { rideId });
export const createRideSecure = (payload) => invoke("createRideSecure", payload);
export const advanceRideSecure = (rideId, targetStatus) => invoke("advanceRideSecure", { rideId, targetStatus });
export const completeRideSecure = (rideId) => invoke("completeRideSecure", { rideId });
export const cancelRideSecure = (rideId, reason = "") => invoke("cancelRideSecure", { rideId, reason });
export const submitRideRatingSecure = (rideId, targetType, rating) => invoke("submitRideRating", {
  rideId,
  targetType,
  stars: rating?.estrelas,
  compliments: rating?.elogios || [],
  comment: rating?.comentario || "",
});
export const changeRidePaymentMethodSecure = (rideId, method, details = {}) => invoke("changeRidePaymentMethodSecure", { rideId, method, details });
